/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileLas = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M19.244 11.887c.253 0 .501.025.745.076.249.046.465.11.649.193v.96a3.996 3.996 0 0 0-.718-.208 3.348 3.348 0 0 0-.676-.076c-.28 0-.494.042-.642.125a.41.41 0 0 0-.213.379c0 .129.052.234.158.317.11.078.315.169.614.27l.524.179c.304.1.546.219.725.352.184.133.315.29.394.469.083.18.124.398.124.655 0 .313-.076.585-.228.815a1.43 1.43 0 0 1-.648.524c-.285.12-.63.18-1.035.18a5.876 5.876 0 0 1-1.215-.131 1.988 1.988 0 0 1-.435-.146v-.959c.258.097.515.17.773.221.262.05.513.076.753.076.29 0 .517-.048.682-.144.166-.097.248-.23.248-.4a.355.355 0 0 0-.158-.298c-.106-.082-.31-.175-.614-.276l-.525-.179c-.427-.147-.74-.336-.938-.566-.193-.235-.29-.533-.29-.897 0-.312.079-.582.235-.807.161-.225.386-.398.676-.518.29-.124.635-.186 1.035-.186zm-9.678 4.154h2.208V17H8.49v-5.017h1.076zM16.99 17h-1.2l-.333-1.028h-1.85L13.276 17h-1.152l1.904-5.017h1.042zm-3.093-1.938h1.266l-.637-1.972z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileLas as FileLas };
